import Vue from 'vue'
import App from './App.vue'

import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
Vue.use(ElementUI)
import './assets/css/common.css'
import './assets/css/style.less'
import Vuex from 'vuex'
Vue.use(Vuex)
import axios from 'axios';
Vue.prototype.axios = axios;
import store from './store'


//productionTip设置为 false ，以阻止 vue 在启动时生成生产提示
Vue.config.productionTip = false


Vue.filter('FormatDate', function(value, type) {
    if (!value) return ''
        // value = value.toString()
        // return new Date(value).toLocaleDateString().replace(/\//g, '-')

    let ret;
    const opt = {
        "Y+": new Date(value).getFullYear().toString(), // 年
        "m+": (new Date(value).getMonth() + 1).toString(), // 月
        "d+": new Date(value).getDate().toString(), // 日
        "H+": new Date(value).getHours().toString(), // 时
        "M+": new Date(value).getMinutes().toString(), // 分
        "S+": new Date(value).getSeconds().toString() // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(type);
        if (ret) {
            type = type.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
    };
    return type;
})


//定义全局变量
// var store = new Vuex.Store({
//     state: {
//         login: false,
//         loginInfo: ''
//     }

// })


new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app')